/**
 * ComponentsIcon/index.js
 * desc: components feature main navigation icon
 * note: entity icon via IconButton; defaults its tooltip + accessible name to the
 *       icon label. Renders an accessible button when given an onClick handler.
 */
'use strict';

import IconButton from '../IconButton';
import { translate } from '../../../utilities/localization';


const ComponentsIcon = ({ tooltip, ...props }) => (
    <IconButton
        baseClassName="components icon"
        // accessible name follows the tooltip override so the visible tip + aria-label always match
        label={ tooltip || translate('icons.components.tooltip.text') }
        tooltip={ tooltip }
        { ...props }
    >
        <svg viewBox="0 0 21 21" xmlns="http://www.w3.org/2000/svg"><path d="M18.5 10H17V6c0-1.1-.9-2-2-2h-4V2.5a2.5 2.5 0 00-5 0V4H2C.9 4 .01 4.9.01 6v3.8H1.5c1.49 0 2.7 1.21 2.7 2.7 0 1.49-1.21 2.7-2.7 2.7H0V19c0 1.1.9 2 2 2h3.8v-1.5c0-1.49 1.21-2.7 2.7-2.7 1.49 0 2.7 1.21 2.7 2.7V21H15c1.1 0 2-.9 2-2v-4h1.5a2.5 2.5 0 000-5z"/></svg>
    </IconButton>
);


export default ComponentsIcon;
